var map = {
	"./0b356bb507d64b9489e2fbced131f795.png": "8117",
	"./5565d66a50b44df9ae37a955bdfb3757.png": "a098",
	"./5ede936757cd4fbdb6247bad22bf454d.png": "db09",
	"./cf1f643bc1244f5e8e37767bc946d607.png": "6479",
	"./happy.png": "8bab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0c54";